var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tag',{staticClass:"ml-1",attrs:{"size":"small","type":_vm.type}},[_vm._v(" "+_vm._s(_vm.rule.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }